import * as React from "react";
import DeviceContext from "../../../../service/indentifyDevice";

if (DeviceContext().isDesktop) {
	require("../../../../../assets/scss/components/toc/fundTransfer/ftAddFund/ftEdelBnkDtlDesk.scss");
} else if (DeviceContext().isMobile) {
	require("../../../../../assets/scss/components/toc/fundTransfer/ftAddFund/ftEdelBnkDtlMob.scss");
} else {
	require("../../../../../assets/scss/components/toc/fundTransfer/ftAddFund/ftEdelBnkDtlTab.scss");
}

export interface IFtEdelBnkDtlProps {
	dpName: string;
	bnkName: string;
	brcName: string;
	bnkAccTyp: string;
	ifsc: string;
	usrAccNo: string;
}

const FtEdelBnkDtl: React.FC<IFtEdelBnkDtlProps> = (props) => {
	return (
		<div className="EdelBnkDtl_wrap">
			<div className="EdelBnkDtl_cont">
				<div className="bank_mesg">We don’t have instant fund transfer facility available for selected bank currently</div>
				<p className="edelBank_mesg">You can transfer fund to your Nuvama account directly through NEFT/RTGS/ IMPS</p>
				<p className="bank_dtl_list">
					<span className="bank_txt">Beneficiary Name</span>
					<span className="bank_val">{props.dpName}</span>
				</p>
				<p className="bank_dtl_list">
					<span className="bank_txt">Beneficiary Bank</span>
					<span className="bank_val">{props.bnkName}</span>
				</p>
				<p className="bank_dtl_list">
					<span className="bank_txt">Bank Branch</span>
					<span className="bank_val">{props.brcName}</span>
				</p>
				<p className="bank_dtl_list">
					<span className="bank_txt">Account Type</span>
					<span className="bank_val">{props.bnkAccTyp}</span>
				</p>
				<p className="bank_dtl_list">
					<span className="bank_txt">IFSC</span>
					<span className="bank_val">{props.ifsc}</span>
				</p>
				<p className="bank_dtl_list">
					<span className="bank_txt">Beneficiary A/C No.</span>
					<span className="bank_val">{props.usrAccNo}</span>
				</p>
			</div>
		</div>
	);
};

export default FtEdelBnkDtl;
